import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import {
  ResetPasswordForm,
  ResetPasswordFormProps
} from 'record-it-components/form/ResetPasswordForm/ResetPasswordForm';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { useSpecificParams } from 'record-it-components/hooks/useSpecificParams/useSpecificParams';
import { ApiAdapter } from '../../../classes/ApiAdapter/ApiAdapter';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';

export type ResetPasswordPageProps = PropsWithoutChildren<Record<never, never>>;

export const ResetPasswordPage: FunctionComponent<ResetPasswordPageProps> =
  React.memo((props) => {
    prepareProps({ props, ignoreChildren: true });

    const navigate = useNavigate();

    const { token } = useSpecificParams({ requiredParamNames: ['token'] });

    const resetPassword: ResetPasswordFormProps['resetPassword'] =
      useEventCallback(async (newPassword) => {
        await ApiAdapter.resetPassword({
          token,
          newPassword
        });
      });

    const handleCancel = useEventCallback(() => {
      navigate(RoutePaths.loginPage());
    });

    const handleFinish = useEventCallback(() => {
      navigate(RoutePaths.loginPage());
    });

    return (
      <ResetPasswordForm
        resetPassword={resetPassword}
        onCancel={handleCancel}
        onFinish={handleFinish}
        data-testid="ResetPasswordPage.ResetPasswordForm"
      ></ResetPasswordForm>
    );
  });
